import React from "react"
import OvertimeGame from "../Game/OvertimeGame"

type OvertimeUniqueEventsProps = {
  leagues: any
  showFilter?: boolean
  isFirstSport?: boolean
}

const OvertimeUniqueEvents: React.FC<OvertimeUniqueEventsProps> = ({
  leagues,
  showFilter = false,
  isFirstSport = false,
}) => {
  console.log({ leagues })
  return (
    <div className="space-y-px">
      {leagues.map(({ countrySlug, slug, games }: any, leagueIndex: number) => {
        const leagueUrl = `/v2/unique/${countrySlug}/${slug}`

        return games.map((game: any, gameIndex: number) => (
          <OvertimeGame
            key={`${leagueUrl}/${game.gameId}`}
            leagueUrl={leagueUrl}
            game={game}
            isUnique
            showFilter={showFilter}
            isFirstGame={isFirstSport && leagueIndex === 0 && gameIndex === 0}
          />
        ))
      })}
    </div>
  )
}

export default OvertimeUniqueEvents
